var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMobileMarketerLogo = function SvgMobileMarketerLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_21)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CA0C6B",
    d: "M9.455 11.386v9.679c0 .36.292.653.653.653h4.784a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-9.678C25 7.307 21.52 4 17.227 4s-7.772 3.307-7.772 7.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_1_21)",
    d: "M0 11.386v9.679c0 .36.293.653.654.653h4.783a.654.654 0 0 0 .654-.654v-8.791a1.681 1.681 0 0 1 3.363 0v8.792c0 .36.293.653.654.653h4.784a.654.654 0 0 0 .654-.654v-9.678C15.546 7.307 12.066 4 7.773 4S0 7.307 0 11.386"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8C3DD",
    d: "M0 16.026h6.09v5.153a.54.54 0 0 1-.54.54H.54a.54.54 0 0 1-.54-.54zM9.455 16.026h6.09v5.153a.54.54 0 0 1-.539.54H9.995a.54.54 0 0 1-.54-.54zM18.91 16.026H25v5.153a.54.54 0 0 1-.539.54h-5.01a.54.54 0 0 1-.54-.54z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21",
    x1: -0.507,
    x2: 24.777,
    y1: 20.464,
    y2: 17.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF158A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766,
    stopColor: "#FF158A",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_21"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgMobileMarketerLogo;